import component from './house-letters.vue';

export default component;